import React, { Component, PropTypes } from 'react';
import { Styles } from 'material-ui';
import { findDOMNode } from 'react-dom';
import { Colors } from 'Css';

let { Spacing } = Styles;

const css = oxygenCss({
  card: {
    backgroundColor: Colors.theme.Light.card
  }
});

export default class ScrollableContainer extends Component {
  static propTypes = {
    header: PropTypes.object,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    headerHeight: PropTypes.number,
    style: PropTypes.object,
    onMount: PropTypes.func,
    containerStyle: PropTypes.object,
    card: PropTypes.bool
  };

  static defaultProps = {
    height: '100%',
    headerHeight: 60,
    style: {},
    containerStyle: {}
  };

  componentDidMount() {
    if (super.componentDidMount) {
      super.componentDidMount();
    }
    const { onMount } = this.props;
    this._pageScrollListener = this.onPageScroll.bind(this);
    this.refs.scrollContainer.addEventListener(
      'scroll',
      this._pageScrollListener,
      false
    );
    onMount && onMount();
  }

  componentWillUnmount() {
    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
    this.refs.scrollContainer.removeEventListener(
      'scroll',
      this._pageScrollListener,
      false
    );
  }

  onPageScroll(event) {
    let node = findDOMNode(this.refs.scrollContainer);
    let containerNode = findDOMNode(this);
    if (node.scrollTop + 10 >= node.scrollHeight - node.clientHeight) {
      if (this.props.onScrollToBottom) {
        this.props.onScrollToBottom();
      }
    }
  }

  getStyle() {
    return Object.assign(
      {},
      {
        height: this.props.height,
        position: 'relative',
        boxSizing: 'border-box'
      },
      this.props.style
    );
  }

  getContainerStyle(hasHeader) {
    return {
        transition: 'all 0.5s ease',
        overflow: 'auto',
        overflowY: 'auto',
        WebkitOverflowScrolling: 'touch',
        position: 'absolute',
        left: 0,
        right: 0,
        bottom: 0,
        top: hasHeader ? this.props.headerHeight : 0
    }
  }

  getToolbarStyle() {
    return Object.assign(
      {},
      {
        position: 'absolute',
        left: 0,
        width: '100%',
        top: 0,
        zIndex: 1
      }
    );
  }

  scrollTo(position) {
    const node = findDOMNode(this.refs.scrollContainer);
    node.scrollTop = position;
  }

  scrollToEnd() {
    const node = this.refs.scrollContainer;
    // const boundingRect = node.getBoundingClientRect();
    node.scrollTop = node.scrollHeight;
  }

  render() {
    let { card, header, style, children, containerStyle, ...other } = this.props;
    return (
      <div
        style={this.getStyle(!!header)}
        {...other}
        className={card ? css.card : null}
      >
        <div style={{...this.getContainerStyle(!!header), ...containerStyle}} ref="scrollContainer">
          {this.props.children}
        </div>
        <div style={this.getToolbarStyle()}>{header}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/ScrollableContainer.js